import { render, staticRenderFns } from "./EmployeeBrandingAdd.vue?vue&type=template&id=4f8f05fa&scoped=true&"
import script from "./EmployeeBrandingAdd.vue?vue&type=script&lang=js&"
export * from "./EmployeeBrandingAdd.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeBrandingAdd.vue?vue&type=style&index=0&id=4f8f05fa&scoped=true&lang=css&"
import style1 from "./EmployeeBrandingAdd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8f05fa",
  null
  
)

export default component.exports